import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { getContractCreateSelectedServiceId, getContractDataGroupId, getServicesCanSubscribe } from '@spaq/core';
import { ServiceInfo } from '@spaq/utils';
import { select, Store } from '@ngrx/store';
import { DataStateChangeEvent, GridComponent, GridDataResult, SelectableSettings } from '@progress/kendo-angular-grid';

import { process, State } from '@progress/kendo-data-query';
import { take, switchMap } from 'rxjs/operators';
import moment from 'moment-timezone';
import { ContractService } from '@shared/store';

@Component({
	selector: 'spaq-services-list',
	template: `
		<div
			[ngClass]="{ isVIP: service && service.meta && service.meta.vip, availableLater: !!(service && service.availableLater) }"
			[id]="'service-row-id-' + service.availableServiceId"
			[attr.data-testid]="'service-row-' + service.availableServiceId"
			*ngFor="let service of services"
			class="card mt-1"
		>
			<div
				class="card-header"
				[ngClass]="{
					'bg-gray': !service.isSubscriptionAvailable,
					availableLater: service.availableLater === true || service.availableLater === false,
					active: (selectedService$ | async) === service.availableServiceId || collapses[service.availableServiceId]
				}"
				(click)="collapse(service)"
			>
				<div class="d-flex flex-row justify-content-between">
					<div class="w-100">
						<input
							[disabled]="!service.isSubscriptionAvailable"
							[checked]="(selectedService$ | async) === service.availableServiceId || collapses[service.availableServiceId]"
							class="k-radio"
							kendoRadioButton
							type="radio"
							id="dasCheck"
							[attr.data-testid]="'service-radio-' + service.availableServiceId"
							value="single"
						/>
						<label class="k-radio-label right w-100 px-2" for="ch4"
							>{{ service.serviceDescription }}
							<span kendoTooltip
								><i title="Cliquez pour obtenir plus d'information" class="fa ps-2 fa-question-circle"></i
							></span>
							<span style="float: right; padding-top: 4px" *ngIf="service && service.meta && service.meta.vip"
								><b>Service VIP</b> ( Invisible pour les utilisateurs réguliers. )</span
							>
						</label>
						<small *ngIf="!service.isSubscriptionAvailable"
							><br /><span style="color: red; padding-left: 28px"
								>La capacité maximale a été atteinte pour ce type d'abonnement, veuillez réessayer plus tard.</span
							></small
						>
						<small *ngIf="service.availableLater === true"
							><br /><span style="color: red; padding-left: 28px"
								>Service disponible à partir du {{ moment(service.webEffectiveDate).format('LL') }}</span
							></small
						>
						<small *ngIf="service.availableLater === false"
							><br /><span style="color: red; padding-left: 28px"
								>Service indisponible depuis le {{ moment(service.webEndDate).format('LL') }}</span
							></small
						>
					</div>
					<div>#{{ service.availableServiceId }}</div>
				</div>
			</div>
			<div
				class="card-body p-4"
				*ngIf="
					((selectedService$ | async) === service.availableServiceId && collapses[service.availableServiceId]) ||
					collapses[service.availableServiceId]
				"
			>
				<spaq-service-detail
					[showStartAt]="false"
					(selectService)="selectService.emit($event)"
					[service]="service"
					[forcePeriodique]="(selectedGroup$ | async)?.forcePeriodique"
					[showButton]="canSubscribe$ | async"
					[showNote]="showNote"
					[isAdmin]="isAdmin"
					[debug]="debug"
				>
					<ng-content></ng-content>
				</spaq-service-detail>
				<!-- <div><pre>
				{{ service | json}}
				</pre></div> -->
			</div>
		</div>
	`,
	styles: [
		`
			.isVIP {
				background-color: #ed969e70;
			}
			.availableLater {
				background-color: #ed969e10 !important;
			}
			.availableLater:hover {
				background-color: #ed969e10 !important;
			}
			.card-header {
				cursor: pointer;
			}

			.bg-gray {
				background-color: #f5f5f5;
				cursor: pointer !important;
			}

			.bg-gray:hover {
				background-color: #f5f5f5 !important;
				cursor: pointer !important;
			}

			.card-header:hover {
				background-color: rgba(0, 0, 0, 0.01);
			}

			.card-header.active {
				background-color: rgba(0, 0, 0, 0.15);
			}

			kendo-grid ::ng-deep kendo-grid-list ::ng-deep tr {
				cursor: pointer !important;
			}

			kendo-grid ::ng-deep kendo-grid-list ::ng-deep tr:hover {
				background-color: #fde9cc;
				color: #000 !important;
			}
		`
	]
})
export class ServicesListComponent implements OnChanges {
	@Input() canSubscribe$ = this.store.pipe(select(getServicesCanSubscribe));
	@Input() selectedService$ = this.store.pipe(select(getContractCreateSelectedServiceId));
	selectedGroup$ = this.store.pipe(select(getContractDataGroupId));
	@Input() debug = false;
	@Input() filterable = true;
	@ViewChild(GridComponent) grid: GridComponent;
	@Input() height = 800;
	mySelection: number[] = [];
	@Output() selectService = new EventEmitter();
	public selectableSettings: SelectableSettings = {
		checkboxOnly: false,
		mode: 'multiple'
	};
	@Input() selected: number;
	selectedData: ServiceInfo;
	selectedIndex = -1;
	@Input() services = [];
	@Input() showNote = true;
	@Input() sortable = true;
	@Input() isAdmin = false;
	@Input() scopeId = null;
	public state: State = {
		skip: 0
	};

	collapses = {};
	public gridData: GridDataResult = process(this.services || [], this.state);

	constructor(
		private store: Store<any>,
		public contractService: ContractService
	) {}
	async collapse(service) {
		if (!service.isSubscriptionAvailable && this.scopeId === 'CSSC' && !this.isAdmin) {
			return false;
		}

		this.contractService.acceptConditionsServiceApprobationPayment(false).pipe(take(1)).subscribe();
		this.contractService
			.deleteService()
			.pipe(
				take(1),
				switchMap(_x => this.contractService.setServiceSelected(service))
			)
			.subscribe();
		this.contractService.acceptWaitList(false).pipe(take(1)).subscribe();
		this.collapses = { [service.availableServiceId]: !this.collapses[service.availableServiceId] };
	}

	ngOnChanges() {
		this.gridData = process(this.services || [], this.state);
		if (this.selected) {
			this.mySelection = [this.selected];
		}
	}
	public dataStateChange(state: DataStateChangeEvent): void {
		this.state = state;
		this.gridData = process(this.services || [], this.state);
	}

	public onSelectedKeysChange(e) {
		const lastSelectedIndex = this.selectedIndex;

		this.grid.collapseRow(this.selectedIndex);

		const _selectedIndex = this.gridData.data.findIndex(park => park.availableServiceId.toString() === e.toString());

		if (_selectedIndex !== lastSelectedIndex) {
			this.selectedIndex = _selectedIndex;

			this.selectedData = this.gridData.data.find(park => park.availableServiceId.toString() === e.toString());

			this.selectService.emit(this.selectedData);
			this.grid.expandRow(this.selectedIndex);
		}
	}

	protected readonly moment = moment;
}
